import Card from './card'

const FounderList = ({ founderList }) => {
  const base = 'grow grid grid-cols-1 lg:grid-cols-2 gap-smallMobile md:gap-mediumDesktop mt-smallMobile md:mt-0'

  return (
    <div className={base}>
      {founderList.map((founder, id) => (
        <Card
          key={id}
          photo={founder.photo}
          name={founder.name}
          position={founder.position}
          description={founder.description}
        />
      ))}
    </div>
  )
}

export default FounderList
